<template lang="pug">
.wrapper
  span.no-results-title {{ t('search.term.notFound.queueTitle') }}
  .no-results-body
    span {{ t('search.term.notFound.queueSubtitle') }}
    .cta
      span {{ t('search.term.notFound.request') }}
      SongRequestButton.no-results-request(:type="'queue'")
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>

<style lang="sass" scoped>
.wrapper
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  .no-results-title
    @include font(basier, semiBold)
    @include fontSize(m)
    color: $color-grey-30
    margin-bottom: $spacing-8
  .no-results-body
    display: flex
    flex-direction: column
    align-items: center
    @include font(basier, regular)
    @include fontSize(s)
    color: $color-grey-60
    text-align: center

    .cta
      display: flex
      flex-direction: row
      align-items: center
      justify-content: center
      gap: $spacing-8

.no-results-request
  :deep(p)
    color: $color-green-70
    text-decoration: underline
    text-decoration-color: $color-green-70
    text-align: center
    &:hover
      color: $color-green-80
      text-decoration-color: $color-green-80
</style>
